
export enum DashboardTabIndexEnum {

  // the number value represents the TabIndex using in URLs like /my-zone/dashboard;tabIndex=2
  tasks           = 0,
  notes           = 1,
  recommendations = 2,
  myTeam          = 3,

}
